/**
 * Klassenbuch Kiosk — RTK Query endpoints.
 *
 * - kioskChipLogin                 → fn_kiosk_chip_login
 * - kioskGetLessonBundle           → get_attendance_bundle_v2 (existing RPC)
 * - kioskGetClassWeek              → fn_klassenbuch_get_class_week
 * - kioskSaveDiary                 → fn_klassenbuch_upsert_diary_entry
 * - kioskSaveAttendance            → save_lesson_attendance_bulk
 * - kioskSaveDayNote               → fn_klassenbuch_upsert_day_note
 * - kioskSaveLesson                → save_lesson_attendance_bulk + diary
 *
 * Auth note: the lesson bundle + save RPCs are granted to `authenticated`
 * only today. The kiosk-JWT role would need an additional grant before
 * paired devices can call these directly — production work, not blocking
 * the admin-tab development path.
 */
import { rootApi } from "../../../lib/api/rootApi";
import { buildKioskQueries } from "./queries";
import { buildKioskMutations } from "./mutations";

export type {
  AttendanceStatus,
  BundleAttendanceRecord,
  BundleStudent,
  KioskBundlePrefill,
  KioskBundlePrefills,
  KioskClassWeekAbsentee,
  KioskClassWeekCell,
  KioskLessonBundle,
} from "../types/kioskApiTypes";

export const klassenbuchKioskApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    ...buildKioskQueries(builder),
    ...buildKioskMutations(builder),
  }),
});

export const {
  useKioskChipLoginMutation,
  useKioskGetLessonBundleQuery,
  useKioskGetClassWeekQuery,
  useKioskSaveLessonMutation,
  useKioskSaveDiaryMutation,
  useKioskSaveAttendanceMutation,
  useKioskSaveDayNoteMutation,
} = klassenbuchKioskApi;
